import React, { FC, useState } from "react";
import { GetPlansResponse, Plan } from "services/quotes/types";
import { PLANS_PAGE_SIZE } from "config/quotes";
import RatesPlansToolbox from "containers/retail/sections/energy-rates-3/RatesPlansToolbox";
import RatesAllPlansTable from "containers/retail/sections/energy-rates-3/RatesAllPlansTable";
import RatesMobileDetailsModal from "containers/retail/sections/energy-rates-3/RatesMobileDetailsModal";
import RatesPagination from "containers/retail/sections/energy-rates-3/RatesPagination";
import Spacer from "evcharging/components/Spacer";
import useI18n from "evcharging/hooks/useI18n";

interface RatesAllPlansProps {
  locationText: string;
  plansResponse: GetPlansResponse;
  onSelectPlan: (plan: Plan) => void;
  isLoading: boolean;
  page: number;
  onFilter: (field: string, value: any) => void;
  onSort: (sort: string) => void;
  onPage: (page: number) => void;
  sort: string;
  filter: {
    effectiveDate: string;
    minEffectiveDate: Date;
    term: string;
  };
}

const RatesAllPlans: FC<RatesAllPlansProps> = (props) => {
  const {
    locationText,
    plansResponse,
    onSelectPlan,
    onFilter,
    filter,
    sort,
    onSort,
    onPage,
    page,
    isLoading
  } = props;
  const { t } = useI18n();
  const { plans, total } = plansResponse;
  const paginationCount = Math.ceil(total / PLANS_PAGE_SIZE);
  const [touchedPlan, setTouchedPlan] = useState<Plan>(null);

  const handlePage = (_, page: number) => {
    onPage(page);
  };

  const onTouchPlan = (plan: Plan) => {
    setTouchedPlan(plan);
  };

  const onCloseTouchPlan = () => {
    setTouchedPlan(null);
  };

  const onSelectTouchedPlan = () => {
    return onSelectPlan(touchedPlan);
  };

  return (
    <>
      <RatesMobileDetailsModal
        show={touchedPlan !== null}
        onClose={onCloseTouchPlan}
        plan={touchedPlan}
        onSelectPlan={onSelectTouchedPlan}
      />
      <RatesPlansToolbox
        locationText={t('rates.all-rates-in-location', { location: locationText })}
        sort={sort}
        onSort={onSort}
        onFilter={onFilter}
        filter={filter}
      />

      <RatesAllPlansTable
        onSelect={onSelectPlan}
        onTouchPlan={onTouchPlan}
        data={plans}
        sort={sort}
        onSort={onSort}
        isLoading={isLoading}
      />

      {total && (
        <>
          <Spacer value={24} />
          <RatesPagination
            page={page}
            paginationCount={paginationCount}
            onChange={onPage}
          />
        </>
      )}
    </>
  );
};

export default RatesAllPlans;
